<template>
    <v-container class="pa-0 ma-0">
        <v-row no-gutters v-if="properties">
            <v-col
                :cols="col"
                class="pb-3 px-1"
                v-for="(keyOpts, index) of filteredKeysAndOptions"
                :key="index"
            >
                <CustomNumberField
                    v-model="properties[keyOpts.key]"
                    v-if="getKeyType(keyOpts.options) === 'number'"
                    :min="getKeyValue(keyOpts.options, 'min')"
                    :max="getKeyValue(keyOpts.options, 'max')"
                    :step="getKeyValue(keyOpts.options, 'step')"
                    class
                    density="compact"
                    hide-details
                    :label="getKeyLabel(keyOpts.options)"
                    :disabled="!isFieldEnabled(keyOpts.options)" />
                <v-select-filled
                    v-model="properties[keyOpts.key]"
                    v-else-if="getKeyType(keyOpts.options) === 'select'"
                    :items="getKeyChoices(keyOpts.options)"
                    :label="getKeyLabel(keyOpts.options)"
                    hide-details="auto"
                    :multiple="!!keyOpts.options.multiple"
                    :disabled="!isFieldEnabled(keyOpts.options)"
                    density="compact"
                    :item-title="(item) => item.title ?? item.text ?? item"
                >
                    <template v-if="!!keyOpts.options.multiple" v-slot:selection="{ item, index }">
                        <span
                            v-if="properties[keyOpts.key] && properties[keyOpts.key].length === 1"
                            >{{ item.raw.text }}</span
                        >
                        <span v-else v-show="index === 0" class="grey--text text-caption">
                            {{ properties[keyOpts.key].length }} sélections
                        </span>
                        gg
                    </template>
                </v-select-filled>
                <v-checkbox
                    v-else-if="getKeyType(keyOpts.options) === 'boolean'"
                    v-model="properties[keyOpts.key]"
                    color="primary"
                    :label="getKeyLabel(keyOpts.options)"
                    density="compact"
                    hide-details="auto"
                    :disabled="!isFieldEnabled(keyOpts.options)"
                >
                </v-checkbox>
                <v-menu
                    offset-y
                    :close-on-content-click="false"
                    v-else-if="
                        getKeyType(keyOpts.options) === 'color' ||
                        getKeyType(keyOpts.options) === 'colour'
                    "
                    @update:model-value="colorMenuInput"
                >
                    <template #activator="{ props }">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-text-field-filled
                                    v-model="properties[keyOpts.key]"
                                    v-bind="props"
                                    :label="getKeyLabel(keyOpts.options)"
                                    readonly
                                    hide-details
                                    density="compact"
                                >
                                    <template v-slot:prepend-inner>
                                        <div
                                            class="d-flex align-self-center"
                                            :style="colorIconStyle(properties[keyOpts.key])"
                                        />
                                    </template>
                                </v-text-field-filled>
                            </v-col>
                        </v-row>
                    </template>
                    <v-color-picker
                        v-model="properties[keyOpts.key]"
                        show-swatches
                        mode="hexa"
                        hide-details="auto"
                        hide-mode-switch
                        :swatches="swatches"
                        :disabled="!isFieldEnabled(keyOpts.options)"
                        v-if="true"
                    >
                    </v-color-picker>
                    <!-- <v-color-picker
                        v-model="
                            invoiceThemeSettings.vatTableBox.header
                                .color
                        "
                        show-swatches
                        mode="hexa"
                        hide-mode-switch
                        :swatches="swatches"
                        :disabled="
                            invoiceThemeSettings.vatTableBox
                                .automaticColors ||
                            invoiceThemeSettings.vatTableBox.style
                                .hidden
                        "
                    >
                    </v-color-picker> -->
                </v-menu>
                <v-menu
                    v-model="isDatePickerOpen"
                    offset-y
                    :close-on-content-click="false"
                    v-else-if="getKeyType(keyOpts.options) === 'date-picker'"
                >
                    <template v-slot:activator="{ props }">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-text-field-filled
                                    :model-value="dateRangeToString(properties[keyOpts.key])"
                                    v-bind="props"
                                    :label="getKeyLabel(keyOpts.options)"
                                    readonly
                                    hide-details
                                    :disabled="!isFieldEnabled(keyOpts.options)"
                                    density="compact"
                                >
                                    <template #prepend-inner>
                                        <div class="d-flex align-self-center">
                                            <v-icon size="x-small">$fa-calendar-alt</v-icon>
                                        </div>
                                    </template>
                                </v-text-field-filled>
                            </v-col>
                        </v-row>
                    </template>
                    <v-date-picker-wrapper
                        v-model="properties[keyOpts.key]"
                        color="gradient"
                        first-day-of-week="1"
                        :type="getKeyValue(keyOpts.options, 'unit')"
                        :min="getKeyValue(keyOpts.options, 'min')"
                        :max="getKeyValue(keyOpts.options, 'max')"
                        multiple="range"
                        style="max-width: 400px"
                        scrollable
                        full-width
                        no-title
                        :landscape="!$vuetify.display.xs"
                        :disabled="!isFieldEnabled(keyOpts.options)"
                    />
                    <v-btn-primary
                        density="default"
                        elevation="0"
                        rounded="xl"
                        @click="isDatePickerOpen = false"
                        size="small"
                        class="mt-2"
                    >
                        Valider
                    </v-btn-primary>
                    <!-- <v-row no-gutters style="max-width: 400px; background-color: white">
                        <v-col cols="12">
                            <v-date-picker
                                v-model="properties[keyOpts.key]"
                                color="gradient"
                                first-day-of-week="1"
                                :type="getKeyValue(keyOpts.options, 'unit')"
                                :min="getKeyValue(keyOpts.options, 'min')"
                                :max="getKeyValue(keyOpts.options, 'max')"
                                multiple="range"
                                style="max-width: 400px"
                                scrollable
                                full-width
                                no-title
                                :landscape="!$vuetify.display.xs"
                                :disabled="!isFieldEnabled(keyOpts.options)"
                            />
                        </v-col>
                        <v-col cols="12" class="d-flex flex-row pr-3 pb-3">
                            <v-spacer />
                            <v-btn-primary
                                color="primary"
                                density="compact"
                                elevation="0"
                                rounded="xl"
                                @click="isDatePickerOpen = false"
                                size="small"
                            >
                                Valider
                            </v-btn-primary>
                        </v-col>
                    </v-row> -->
                </v-menu>
                <v-text-field-filled
                    v-else
                    v-model="properties[keyOpts.key]"
                    outlined
                    hide-details="auto"
                    class
                    :label="getKeyLabel(keyOpts.options)"
                    :disabled="!isFieldEnabled(keyOpts.options)"
                    density="compact"
            /></v-col>
        </v-row>
    </v-container>
</template>
<script lang="ts">
import moment from "moment-timezone";
import CustomNumberField from "../invoiceTheme/CustomNumberField.vue";
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        CustomNumberField,
    },
})
export class PropertiesEditor extends Vue {
    @Prop({ required: true }) properties: any;
    @Prop({ required: true }) propertiesOptions: any;
    @Prop({ default: 2, type: [Number, undefined] }) perRow: number | undefined;
    @Prop({ default: null, required: false }) exclusionList: string[];

    beforeMount() {
        console.log("properties", this.properties);
    }

    isDatePickerOpen = false;

    swatches = [
        // ['#1abc9c','#2ecc71','#16a085','#95a5a6','#7f8c8d'],
        // ['#27ae60','#3498db','#2980b9','#c0392b','#ecf0f1'],
        // ['#9b59b6','#8e44ad','#34495e','#e67e22','#e74c3c'],
        // ['#2c3e50','#f1c40f','#f39c12','#d35400','#bdc3c7'],
        ["#b2e2f2ff", "#b0c2f2ff", "#84b6f4ff"],
        ["#77dd77ff", "#b0f2c2ff", "#d8f8e1ff"],
        ["#fcb7afff", "#fabfb7ff", "#ffe4e1ff"],
        ["#fdfd96ff", "#ffda9eff", "#fdf9c4ff"],
        ["#ffffffff", "#f5f5f5ff", "#efefefff"],
        ["#00000000"],
    ];

    get col() {
        if (!this.perRow || this.perRow < 1) {
            return 12;
        }
        return Math.round(12 / Math.min(12, this.perRow));
    }

    get keys() {
        if (this.properties) {
            return Object.keys(this.properties);
        }
        return [];
    }

    get keysAndOptions() {
        const out = [];
        for (const key of this.keys) {
            const options = this.propertiesOptions?.[key];
            out.push({
                key,
                options,
            });
        }

        console.log("out", out);
        return out;
    }

    get filteredKeysAndOptions() {
        // console.log("filteredKeysAndOptions", this.keysAndOptions.filter(x => /*this.properties?.[x.key] != null &&*/ this.validatesPrerequisites(x.options) && !this.isObjectExcludingArray(this.properties[x.key])))
        return this.keysAndOptions.filter(
            (x) =>
                /*this.properties?.[x.key] != null &&*/ (!this.exclusionList ||
                    !this.exclusionList.includes(x.key)) &&
                x.options?.visible !== false &&
                this.validatesPrerequisites(x.options) &&
                !this.isObjectExcludingArray(this.properties[x.key]),
        );
    }

    dateRangeToString(dateRange: (string | Date)[] | null) {
        if (!dateRange?.length) {
            return "";
        }
        const format = "DD/MM/YYYY";
        console.log("dateRange", dateRange, typeof dateRange);
        if (dateRange.length === 1) {
            return moment(dateRange[0]).format(format);
        }
        const datesCopy = dateRange.toSorted((a, b) => {
            return moment(a).isBefore(moment(b)) ? -1 : 1;
        });
        return (
            moment(datesCopy[0]).format(format) +
            " - " +
            moment(datesCopy[datesCopy.length - 1]).format(format)
        );
    }

    getKeyLabel(keyOptions) {
        return keyOptions?.label;
    }

    getKeyType(keyOptions) {
        return keyOptions?.type;
    }

    getKeyChoices(keyOptions) {
        console.log("keyOptions?.choices", keyOptions?.choices);
        return keyOptions?.choices;
    }

    getKeyValue(keyOptions, kw) {
        if (!keyOptions || kw == null) {
            return null;
        }
        return keyOptions?.[kw];
    }

    validatesPrerequisites(keyOptions) {
        return this.testFieldsValues(keyOptions?.prerequisites);
        // if (!keyOptions?.prerequisites) {
        //     return true
        // }
        // for (const prereq of (keyOptions?.prerequisites ?? [])) {

        //     if (prereq.clause) {
        //         switch(prereq.clause.toUpperCase()) {
        //             case "OR":
        //                 if (!this.validateOrClause(prereq.conditions)) {
        //                     return false
        //                 }
        //                 break
        //             default:
        //                 // Do nothing. Prereq is ignored
        //                 // TODO: add other case, AND, XOR, ...
        //         }
        //     } else {
        //         if (Array.isArray(prereq.value)) {
        //             if (!prereq.value.includes(this.properties?.[prereq.key])) {
        //                 return false
        //             }
        //         } else if (typeof prereq.value === "boolean" && typeof this.properties?.[prereq.key] !== "boolean") {
        //             return prereq.value === !!this.properties?.[prereq.key]
        //         } else if (this.properties?.[prereq.key] !== prereq.value) {
        //             return false
        //         }
        //     }
        // }
        // return true
    }

    validateOrClause(conditions: { key: string; value: any }[]): boolean {
        if (!conditions?.length) {
            return true;
        }
        for (const condition of conditions) {
            if (Array.isArray(condition.value)) {
                if (condition.value.includes(this.properties?.[condition.key])) {
                    return true;
                }
            } else if (
                typeof condition.value === "boolean" &&
                typeof this.properties?.[condition.key] !== "boolean"
            ) {
                if (condition.value === !!this.properties?.[condition.key]) return true;
            } else if (this.properties?.[condition.key] === condition.value) {
                return true;
            }
        }
        return false;
    }

    isFieldEnabled(keyOptions) {
        return this.testFieldsValues(keyOptions?.enableConditions);
        // if (!keyOptions?.enableConditions) {
        //     return true
        // }
        // for (const cond of (keyOptions?.enableConditions ?? [])) {
        //     if (Array.isArray(cond.value)) {
        //         if (!cond.value.includes(this.properties?.[cond.key])) {
        //             return false
        //         }
        //     } else if (typeof cond.value === "boolean" && typeof this.properties?.[cond.key] !== "boolean") {
        //         return cond.value === !!this.properties?.[cond.key]
        //     } else if (this.properties?.[cond.key] !== cond.value) {
        //         return false
        //     }
        // }
        // return true
    }

    testFieldsValues(conditionsList: any[]) {
        if (!conditionsList?.length) {
            return true;
        }
        for (const prereq of conditionsList) {
            if (prereq.clause) {
                switch (prereq.clause.toUpperCase()) {
                    case "OR":
                        if (!this.validateOrClause(prereq.conditions)) {
                            return false;
                        }
                        break;
                    default:
                    // Do nothing. Prereq is ignored
                    // TODO: add other case, AND, XOR, ...
                }
            } else {
                if (Array.isArray(prereq.value)) {
                    if (!prereq.value.includes(this.properties?.[prereq.key])) {
                        return false;
                    }
                } else if (
                    typeof prereq.value === "boolean" &&
                    typeof this.properties?.[prereq.key] !== "boolean"
                ) {
                    return prereq.value === !!this.properties?.[prereq.key];
                } else if (this.properties?.[prereq.key] !== prereq.value) {
                    return false;
                }
            }
        }
        return true;
    }

    colorIconStyle(color) {
        return {
            "margin-top": "5px",
            height: "15px",
            width: "15px",
            "border-radius": "10px",
            "z-index": "1",
            "background-color": color,
        };
    }

    isObjectExcludingArray(val) {
        return val !== null && typeof val === "object" && !Array.isArray(val);
    }

    showColorPicker = false;
    /**
     *   v-color-picker null value problem fix: https://github.com/vuetifyjs/vuetify/issues/12117
     **/
    colorMenuInput(val) {
        this.showColorPicker = val;
    }
}

export default toNative(PropertiesEditor);
</script>
<style lang="css" scoped>
/* ::v-deep .v-label {
    font-size: 0.8em;
} */
:deep(:is(input, .v-label, .v-select__selection)) {
    font-size: 0.8em;
}
</style>
